import { Link } from 'react-router-dom';
import { cn } from '@/lib/utils';
import logoUrl from '../../assets/logo.png';

interface LogoProps {
  className?: string;
  variant?: 'default' | 'light';
  size?: 'sm' | 'md' | 'lg' | 'xl' | '2xl';
  heightPx?: number; // optional custom height override
}

export function Logo({ className, variant = 'default', size = 'md', heightPx }: LogoProps) {
  const sizeClass =
    size === 'sm' ? 'h-8' :
    size === 'lg' ? 'h-16' :
    size === 'xl' ? 'h-28' :
    size === '2xl' ? 'h-32' :
    'h-12';
  return (
    <Link
      to="/"
      className="group flex items-center gap-2 transition-all duration-300 hover:scale-105"
      aria-label="Home"
    >
      <img
        src={logoUrl}
        alt="Security Engineers logo"
        className={cn(
          className || (heightPx ? '' : sizeClass), 
          'w-auto object-contain',
          variant === 'light' ? '' : ''
        )}
        style={heightPx ? { height: `${heightPx}px` } : undefined}
        loading="eager"
      />
    </Link>
  );
}
